import React, { useCallback, useRef } from 'react';
import Toast, { ToastMessage } from './Toast';

export interface ToastContextType {
  showToast: (message: string, type: 'success' | 'error' | 'info', duration?: number) => void;
}

export const ToastContext = React.createContext<ToastContextType | undefined>(undefined);

interface ToastContainerProps {
  children: React.ReactNode;
}

export const ToastProvider: React.FC<ToastContainerProps> = ({ children }) => {
  const [toasts, setToasts] = React.useState<ToastMessage[]>([]);
  const toastIdRef = useRef(0);

  const showToast = useCallback(
    (message: string, type: 'success' | 'error' | 'info' = 'info', duration?: number) => {
      const id = `toast-${toastIdRef.current++}`;
      const newToast: ToastMessage = {
        id,
        type,
        message,
        duration,
      };
      setToasts((prev) => [...prev, newToast]);
    },
    []
  );

  const handleCloseToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {/* Toast Container */}
      <div className="fixed top-4 right-4 z-50 space-y-2 max-w-md">
        {toasts.map((toast) => (
          <Toast key={toast.id} message={toast} onClose={handleCloseToast} />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = React.useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};
